import * as React from 'react';
import classNames from 'classnames';
import { CnBox } from '@/components/cn-box';
import { Indicator } from './indicator';
const prefix = 'cn-ui-m-';
/** Loading */
export const CnLoading = (props) => {
    const { tip, visible, children, className, style, tipAlign, isGradient, size, inverse, ...others } = props;
    const cls = classNames({
        'cn-ui-m-loading': true,
        [`cn-ui-m-loading-${size}`]: true,
        [`${prefix}open`]: visible,
        'cn-ui-m-loading-inverse': inverse,
    });
    const svgCls = classNames({
        'cn-load-svg': true,
        [`cn-load-svg-${size}`]: true,
    });
    const indicatorDom = isGradient ? (React.createElement(Indicator, { className: svgCls, inverse: inverse })) : (React.createElement("div", { className: "cn-load" }));
    const spacing = React.useMemo(() => {
        let spacingNum = 8;
        switch (size) {
            case 'large':
                spacingNum = 12;
                break;
            case 'small':
                spacingNum = 4;
                break;
            default:
                break;
        }
        return spacingNum;
    }, [size]);
    const tipCls = classNames({
        [`${prefix}loading-tip`]: true,
    });
    // 不做遮罩，直接不渲染子节点
    if (visible) {
        return (React.createElement("div", { className: cls, style: style, ...others },
            React.createElement(CnBox, { spacing: spacing, direction: tipAlign === 'right' ? 'row' : 'column', align: "center", justify: "center", className: tipCls },
                React.createElement("div", { className: `${prefix}loading-indicator` }, indicatorDom),
                React.createElement("div", { className: `${prefix}loading-tip-content` }, tip))));
    }
    return (React.createElement("div", { className: className, style: style, ...others }, children));
};
CnLoading.displayName = 'CnLoading';
CnLoading.defaultProps = {
    visible: true,
    animate: null,
    tipAlign: 'bottom',
    size: 'medium',
    disableScroll: false,
    isGradient: true,
};
